import React, { useState } from 'react';

import { AddName } from './TextField';
import { ConfirmBtn } from './Button';

import { Avatar, Button, Dialog, DialogActions, DialogContent, DialogTitle, Icon, List, ListItem, ListItemIcon, ListItemText, makeStyles } from '@material-ui/core';
import { AccountCircle } from '@material-ui/icons';
import { useGoogleLogin } from 'react-google-login';

const useStyles = makeStyles((theme) => ({
    Title : {
        fontFamily: 'regular !important',
        fontWeight: '400 !important',
        fontSize: '1.2rem !important',
        lineHeight: '24px',
        letterSpacing: '-0.011em',
        marginTop: '2vh',
    },
    Content : {
        fontFamily: 'regular !important',
        fontWeight: '400 !important',
        fontSize: '1.2rem !important',
        lineHeight: '24px',
        letterSpacing: '-0.011em',
    },
    label : {
        fontFamily: 'regular !important',
        fontWeight: '400 !important',
        fontSize: '1rem !important',
    },
    dialog : {
        backgroundColor : 'black',
        color : 'white',
        boxShadow: '-1px -1px 10px 0px #1c1c1c',
    },
    accList : {
        color : '#e5e7eb',
    },
    accMail : {
        color : '#343434',
        '&:hover' : {
            color : '#fe752f'
        }
    },
    bg : {
        backgroundColor: '#373737'
    },
    signIn : {
        fontSize : '1.5rem !important',
        marginTop : '2vh', 
        color:'#e5e7eb',
        textTransform: 'none',
        '&:hover' : {
            color : '#fe752f'
        },
        '&:hover .MuiIcon-root' : {
            color : '#fe752f'
        },
    },
    svg : {
        width: '1.5em !important',
            height : '1.5em !important',
        color : '#e5e7eb',
        "& .MuiIcon-root" : {
            width: '1.5em !important',
            height : '1.5em !important',
            color : '#e5e7eb',
        },
        '&:hover .MuiIcon-root' : {
            color : '#fe752f'
        }
    },
    list: {
        textAlign : 'center',
    },
}));

const clientId = "1046785123269-gg6ob1gdpql3nfdd9h9ispclce9b8ipj.apps.googleusercontent.com";

const PrivatePrompt =  function PrivatePrompt({ show, signStatus, handleClose, handleJoinRoom }){

    const classes = useStyles();
    const [hover, setHover] = useState(false);


    const onSuccess = (res) => {
        console.log("Login succ",res)
        let obj = res.profileObj;
        obj.ttl = (+new Date + 1296000);
        localStorage.setItem("auth",JSON.stringify(obj));
        handleJoinRoom(`${obj.name}(${obj.email})`)
        handleClose()
    }

    const onFailure = (res) => {
        console.log("Login fail",res)
    }

    const defaultLogin = () => {
        let obj = JSON.parse(localStorage.getItem("auth"));
        handleJoinRoom(`${obj.name}(${obj.email})`)
        handleClose()
    }

    const { signIn } = useGoogleLogin({
        onSuccess,
        clientId,
        onFailure,
        cookiePolicy:'single_host_origin'
    })

    const handleText = (text) => {
        if(text){ 
            if(text.length>20) {
                return text.slice(0,14)+"..."+text.slice(text.length-3)
            } 
            return text
        }
        return ""
    }

    return(
        <Dialog classes={{ paper : classes.dialog, root : classes.bg}} open={show || false} >
            <DialogTitle  disableTypography={true} classes={{ root : classes.Title }} >
                { (!signStatus) ? "Authorization required to join the private portal" : "Continue with existing account" }
            </DialogTitle>
            <DialogContent classes={{ root : classes.Content }} >
                <List classes={{root: classes.list}}>
                        {
                            signStatus ? 
                            <ListItem classes={{ root:classes.accList}} onClick={defaultLogin} button>
                                <ListItemIcon classses={{ root : classes.svg }} >
                                        <Avatar 
                                            alt="signed-in"
                                            aria-haspopup="true"
                                            src={JSON.parse(localStorage.getItem("auth")).imageUrl}
                                            classes={{ root : classes.avatar }}
                                            >
                                                <AccountCircle />
                                            </Avatar>
                                </ListItemIcon>
                                <ListItemText classes={{secondary: classes.accMail}} primary={JSON.parse(localStorage.getItem("auth")).name} secondary={handleText(JSON.parse(localStorage.getItem("auth")).email)} />
                            </ListItem>
                            :
                            null
                        }
                        <Button
                        onClick={signIn}
                        onMouseEnter={() => setHover(true)}
                        onMouseLeave={() => setHover(false)}
                        classes = {{ root : classes.signIn }}
                        startIcon={
                            <Icon classes={{ root : classes.svg }} >
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" className={(hover)?"GSvgHover":"GSvg"} ><path d="M12.24 10.285V14.4h6.806c-.275 1.765-2.056 5.174-6.806 5.174-4.095 0-7.439-3.389-7.439-7.574s3.345-7.574 7.439-7.574c2.33 0 3.891.989 4.785 1.849l3.254-3.138C18.189 1.186 15.479 0 12.24 0c-6.635 0-12 5.365-12 12s5.365 12 12 12c6.926 0 11.52-4.869 11.52-11.726 0-.788-.085-1.39-.189-1.989H12.24z"></path></svg>
                            </Icon>
                        }
                        >
                            { signStatus ? "Switch account" : "Sign In" }
                        </Button>
                </List>
            </DialogContent>
        </Dialog>
    )

}

export default PrivatePrompt;